import { HeartFilledIcon, HeartIcon } from "../../icons";
import { classNames } from "../../support/formatters/class-formatter";
import type { Optional } from "../../types";

import styles from "./favorite-button.module.css";

export function FavoriteButton({
  isFavorite = false,
  onFavoriteClick = () => {},
  dataQA,
  ...props
}: Readonly<{
  isFavorite?: Optional<boolean>;
  onFavoriteClick?: Optional<() => void | Promise<void>>;
  dataQA?: string;
}>) {
  return (
    <button
      type="button"
      className={classNames(
        styles.FavoriteButton,
        isFavorite ? styles.Active : ""
      )}
      onClick={onFavoriteClick || undefined}
      data-qa={dataQA}
    >
      {isFavorite ? (
        <HeartFilledIcon
          className={styles.Icon}
          size={16}
          viewBox="0 0 24 24"
          color="#FFF"
          {...props}
        />
      ) : (
        <HeartIcon
          className={styles.Icon}
          size={16}
          viewBox="0 0 24 24"
          color="#6A6977"
          {...props}
        />
      )}
    </button>
  );
}
